module.exports = __webpack_public_path__ + "static/media/bankSlip.3c617f28.png";